export const setSchemas = schemas => ( {
	type: 'SETRAWSCHEMAS',
	payload: schemas
} )

export const another = true